import { AxiosResponse } from 'axios';

export const ExtractPhxRequestId = (res: AxiosResponse): string => {
  return res.config.headers['x-phx-request-id'];
};
